module.exports = __webpack_public_path__ + "static/media/mountain-light.acc6b1df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/mountain-light.jpg
// module id = 308
// module chunks = 0